import { render, staticRenderFns } from "./EventContact.vue?vue&type=template&id=74220dd6"
import script from "./EventContact.vue?vue&type=script&lang=js"
export * from "./EventContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports